import type { LinkMapping } from "../types/shared";

// General
export const CURRENT_BRAND = "Scott";

// SAP Commerce Cloud
export const SITE_UID = "SITE_UID";
export const DEFAULT_FETCH_TIMEOUT_MS = 15_000;
export const ANONYMOUS_USER_COMPONENTS_URL = "users/anonymous/cms/components";
export const BASE_API_URL = process.env.BASE_API_URL;
export const COPYRIGHT_TEMPLATE =
  "Copyright © [YEAR] [BRAND_NAME]. All Rights Reserved.";
export const LANGUAGE_HEADER = "accept-language";
export const D2C_PATHNAME_HEADER = "x-d2c-pathname";
// Preview/draft state resolved by the proxy and forwarded to the render, so the
// render never calls draftMode() (a dynamic API) outside the draft API routes.
export const DRAFT_MODE_HEADER = "x-draft-mode";

// Anonymous SAP CMS header/footer components (nav, footer links, payment icons)
// are not stock-sensitive, so they are cached across requests instead of
// re-fetched on every page render. Tags allow an on-demand purge once a CMS
// publish webhook is wired up. Tune the TTL here.
export const CMS_COMPONENT_REVALIDATE_SECONDS = 3600;
export const HEADER_CMS_CACHE_TAG = "cms-header";
export const FOOTER_CMS_CACHE_TAG = "cms-footer";
export const WEBSITE_LOCALE = "website-locale";
export const COUNTRY_NAVIGATION_BAR_COOKIE_NAME =
  "CountryNavigationPanelClosed";
export const COUNTRY_NAVIGATION_BAR_SELECT_LOCATION_URL = "/country";
/**
 * Remembers the page the country switch started from. The switch itself is
 * accelerator-owned and returns to the last page the accelerator served, which
 * for a Next-rendered page is nothing at all, so it falls back to the locale
 * root. The accelerator ignores any return-URL parameter, so the return trip
 * has to be restored on this side.
 */
export const COUNTRY_SWITCH_RETURN_COOKIE = "_countrySwitchReturn";
export const COUNTRY_SWITCH_RETURN_MAX_AGE_MINUTES = 10;
export const COUNTRY_COOKIE = "_country";
export const LANGUAGE_COOKIE = "_language";
export const WAF_COUNTRY_HEADER = "_yourcountry"; // Web Application Firewall country header
export const DEFAULT_COUNTRY = "global";
export const DEFAULT_LANGUAGE = "en";
export const allCountries = [
  "fo",
  "cv",
  "xs",
  "mk",
  "gf",
  "ky",
  "ci",
  "li",
  "mq",
  "JO",
  "MK",
  "PK",
  "UZ",
  "tt",
  "jm",
  "gl",
  "vg",
  "ma",
  "ao",
  "dz",
  "bw",
  "sz",
  "mz",
  "ke",
  "zm",
  "bf",
  "rs",
  "al",
  "kg",
  "tc",
  "am",
  "xx",
  "ax",
  "ck",
  "gp",
  "om",
  "kw",
  "qa",
  "mf",
  "bm",
  "bh",
  "mm",
  "vn",
  "sm",
  "lk",
  "gov",
  "bo",
  "hn",
  "ir",
  "tk",
  "sl",
  "mo",
  "kh",
  "np",
  "sh",
  "eg",
  "co",
  "xk",
  "gy",
  "do",
  "zw",
  "by",
  "mc",
  "pa",
  "az",
  "aw",
  "ge",
  "eu",
  "ve",
  "uy",
  "ae",
  "ua",
  "tr",
  "th",
  "si",
  "sk",
  "sg",
  "ro",
  "re",
  "ph",
  "pe",
  "py",
  "nc",
  "mu",
  "mt",
  "my",
  "mg",
  "lb",
  "kz",
  "il",
  "id",
  "is",
  "gt",
  "pf",
  "sv",
  "ec",
  "cy",
  "hr",
  "cr",
  "cn",
  "cl",
  "bg",
  "bn",
  "ar",
  "me",
  "hk",
  "ba",
  "mx",
  "md",
  "lv",
  "pr",
  "lu",
  "ee",
  "na",
  "er",
  "ad",
  "lt",
  "ie",
  "jp",
  "gr",
  "dk",
  "ca",
  "be",
  "au",
  "za",
  "tw",
  "sa",
  "nz",
  "no",
  "nl",
  "in",
  "hu",
  "fi",
  "kr",
  "pl",
  "br",
  "se",
  "cz",
  "pt",
  "it",
  "es",
  "ru",
  "us",
  "gb",
  "fr",
  "ch",
  "at",
  "global",
  "de",
];

//Analytics
//Divisions
export const DIVISION_BIKE = "Bike";
//PageTypes
export const PAGETYPE_BIKE_REGISTRATION = "Bike Registration";
export const SCOTT_DASH_LX = "The_Scott_Circle";

// Hybris / PIM
export const PIM_ENDPOINT =
  "/scottwebservices/rest/products-ws/detail/Scott%20PIM%20Master/online";
export const CLASSIFICATION_FILTERS_BIKES = "filters_bikes";
export const FILTER_MODEL = "filter_model";

// S4HANA
export const SERIAL_NUMBER_ENDPOINT = "/SCOTT/ws/prod_reg/getequipment";
export const MODEL_NAME_ENDPOINT = "/SCOTT/ws/ebike/getCollection";
export const RIDERS_CLUB_FREE_ORDER_ENDPOINT = "/ridersClubFreeOrder";
export const AREA_AVAILABILITY_ENDPOINT = "/productAreaAvailability";
export const OAUTH_TOKEN_ENDPOINT = "/authorizationserver/oauth/token";

// CDC
export const LITE_TOKEN = "/accounts.getLiteToken";
export const INIT_REGISTRATION = "/accounts.initRegistration";
export const SET_ACCOUNT_INFO = "/accounts.setAccountInfo";
export const GET_ACCOUNT_INFO = "/accounts.getAccountInfo";

// CDP
export const CDP_OAUTH_URL = "https://oauth2.us1.gigya.com/oauth2/token";

// Emarsys
export const EMARSYS_STAGING_USER = "scott_sports_stg01002";
export const EMARSYS_ENDPOINT = "/api/v2/email/";
export const EMARSYS_BROADCAST_SEGMENT = "/broadcast";

// OpenCage
export const OPENCAGE_ENDPOINT = "https://api.opencagedata.com/geocode/v1/json";

export const EMARSYS_EMAIL_IDS = {
  ES: {
    TEST: 179_878,
    PROD: 445_489,
  },
  FR: {
    TEST: 179_876,
    PROD: 445_494,
  },
  IT: {
    TEST: 179_875,
    PROD: 445_498,
  },
  DE: {
    TEST: 179_874,
    PROD: 445_472,
  },
  EN: {
    TEST: 177_544,
    PROD: 445_464,
  },
  ERROR: {
    TEST: 179_914,
    PROD: 456_096,
  },
} as const;

export const languages: Record<string, { value: string; label: string }[]> = {
  scott: [
    { value: "en", label: "English" },
    { value: "fr", label: "French" },
    { value: "de", label: "German" },
    { value: "it", label: "Italian" },
    { value: "es", label: "Spanish" },
  ],
  dolomite: [
    { value: "en", label: "English" },
    { value: "fr", label: "French" },
    { value: "de", label: "German" },
    { value: "it", label: "Italian" },
  ],
  syncros: [
    { value: "en", label: "English" },
    { value: "fr", label: "French" },
    { value: "de", label: "German" },
    { value: "it", label: "Italian" },
  ],
  bergamont: [
    { value: "en", label: "English" },
    { value: "de", label: "German" },
  ],
};

export const genders: Record<string, { value: string; label: string }[]> = {
  scott: [
    { value: "m", label: "Male" },
    { value: "f", label: "Female" },
    { value: "u", label: "Other" },
  ],
};

export const ENV_SYSTEM_ERROR_MESSAGE =
  "Verify that all the required ENVIRONMENT VARIABLES are set.";

export const EMAIL_ADDRESS_FOR_ERRORS = "support.webservice@scott-sports.com";

export const TranslationKeys = {
  ERROR: "error",
  UNEXPECTED: "unexpected",
  VALIDATION: "validation",
  GIGYAERROR: "gigyaError",
  SystemError: "errorMessages.systemError",
  DataError: "errorMessages.dataError",
  Step1SnWrong: "steps.step1.snInput.snWrong",
  AlreadyBikeClubMemberError: "errorMessages.alreadyBikeClubMemberError",
  notEligibleToRidersClubMsg: "steps.step1.bikeNotEligibleMessage",
  customerDoesNotExistMsg: "steps.step1.customerDoesNotExistMessage",
  alreadyPartInfoMessage: "steps.step1.alreadyPartInfoMessage",
  bikeNotRegistredMsg: "steps.step1.bikeNotRegistredMessage",
} as const;

export type TranslationKeys =
  (typeof TranslationKeys)[keyof typeof TranslationKeys];

// Translations - RichTextDisplay
export const RichTextLinkType = {
  CONTACT_US: "CONTACT_US",
  WARRANTY: "WARRANTY",
  WARRANTY_POLICY: "WARRANTY_POLICY",
  BIKE_REGISTRATION: "BIKE_REGISTRATION",
  NONE: "NONE",
} as const;

export type RichTextLinkType =
  (typeof RichTextLinkType)[keyof typeof RichTextLinkType];

// @ts-expect-error not today
export const LINK_DATA: Record<RichTextLinkType, LinkMapping> = {
  [RichTextLinkType.CONTACT_US]: {
    key: "contactLink",
    href: "/company/contact",
  },
  [RichTextLinkType.WARRANTY_POLICY]: {
    key: "warrantyPolicyLink",
    href: "/support/warranty",
    target: "_blank",
    rel: "noopener noreferrer",
  },
  [RichTextLinkType.BIKE_REGISTRATION]: {
    key: "registerBikeLink",
    href: "/support/registration",
  },
};

// RECAPTCHA ERROR CODES
export const errorCodesToCheck = [
  "recaptcha-connection-failed",
  "missing-input-secret",
  "invalid-input-secret",
];

export const BRAND_TITLES: Record<string, string> = {
  scott: "Scott",
  dolomite: "Dolomite",
  syncros: "Syncros",
  bergamont: "Bergamont",
};

export const BRAND_DESCRIPTION: Record<string, string> = {
  scott: "Scott",
  dolomite: "Dolomite",
  syncros: "Syncros",
  bergamont: "Bergamont",
};

export const BRAND_ACESSIBE_COLORS: Record<string, string> = {
  scott: "09f",
  dolomite: "1a345c",
  syncros: "33cc33",
  bergamont: "009ee2",
};

export const COPYRIGHT_BRAND_NAMES: Record<string, string> = {
  scott: "SCOTT Sports SA",
  dolomite: "DOLOMITE S.R.L",
  syncros: "SCOTT Sport SA",
};
